import React from 'react';
import { useAuth } from '../../lib/auth.context';
import { Card } from '../../components/ui/card';
import { useUserProfile } from '../../hooks/useUserProfile';
import { ChangePasswordForm } from '../../components/auth/change-password-form';

const SettingsPage: React.FC = () => {
  const { user } = useAuth();
  const { profile, isLoading } = useUserProfile();

  return (
    <div className="container mx-auto py-8 pl-60">
      <div className="w-full max-w-md">
        <h1 className="text-xl font-bold mb-6 text-[#CECFD2]" id="settings-heading">Settings</h1>
        
        <Card className="p-6 mb-6 border border-gray-700 bg-[#121212] shadow-lg rounded-lg w-full">
          <h2 className="text-lg font-bold mb-4 text-[#CECFD2]">Account Information</h2>
          {user && (
            <div className="space-y-4 text-[#CECFD2]">
              <div>
                <span className="font-medium">Email:</span> {user.email}
              </div>
              
              {isLoading ? (
                <div className="flex items-center space-x-2 text-[#CECFD2]" aria-live="polite" aria-busy="true">
                  <div className="h-4 w-4 rounded-full border-2 border-current border-r-transparent animate-spin"></div>
                  <span>Loading club information...</span>
                </div>
              ) : profile ? (
                <div>
                  <span className="font-medium">Club:</span> {profile.clubName}
                </div>
              ) : null}
            </div>
          )}
        </Card>
        
        <Card className="p-6 border border-gray-700 bg-[#121212] shadow-lg rounded-lg w-full">
          <ChangePasswordForm />
        </Card>
      </div>
    </div>
  );
};

export default SettingsPage;